import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { inventoryService } from "../../services/inventoryService";

export const fetchProducts = createAsyncThunk(
  "inventory/fetch",
  async (params, { rejectWithValue }) => {
    try {
      const res = await inventoryService.list(params);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error ?? "Ürünler yüklenemedi");
    }
  }
);

export const createProduct = createAsyncThunk(
  "inventory/create",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await inventoryService.create(payload);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error ?? "Ürün eklenemedi");
    }
  }
);

export const updateProduct = createAsyncThunk(
  "inventory/update",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const res = await inventoryService.update(id, payload);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error ?? "Ürün güncellenemedi");
    }
  }
);

export const setProductActive = createAsyncThunk(
  "inventory/setActive",
  async ({ id, active }, { rejectWithValue }) => {
    try {
      const res = await inventoryService.setActive(id, active);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error ?? "Durum değiştirilemedi");
    }
  }
);

export const hardDeleteProduct = createAsyncThunk(
  "inventory/hardDelete",
  async (id, { rejectWithValue }) => {
    try {
      await inventoryService.hardRemove(id);
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error ?? "Ürün silinemedi");
    }
  }
);

/** Stok hareketi ekler; dönen güncel ürünü değil, hareketi verir — ürünü yeniden çekmek çağıranın işi. */
export const addStockMovement = createAsyncThunk(
  "inventory/addMovement",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const res = await inventoryService.addMovement(id, payload);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error ?? "Stok hareketi kaydedilemedi");
    }
  }
);

const upsert = (state, updated) => {
  const i = state.items.findIndex((p) => p.id === updated.id);
  if (i !== -1) state.items[i] = { ...state.items[i], ...updated };
};

const inventorySlice = createSlice({
  name: "inventory",
  initialState: { items: [], isLoading: false, error: null },
  reducers: {
    clearInventoryError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProducts.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchProducts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.items = action.payload.content ?? [];
      })
      .addCase(fetchProducts.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(createProduct.fulfilled, (state, action) => {
        state.items.unshift(action.payload);
      })
      .addCase(updateProduct.fulfilled, (state, action) => upsert(state, action.payload))
      .addCase(setProductActive.fulfilled, (state, action) => upsert(state, action.payload))
      .addCase(hardDeleteProduct.fulfilled, (state, action) => {
        state.items = state.items.filter((p) => p.id !== action.payload);
      });
  },
});

export const { clearInventoryError } = inventorySlice.actions;
export default inventorySlice.reducer;
